<template>
  <div>
    <v-row
      align="center"
      no-gutters
      class="py-2"
    >
      <v-col class="text-body-1">
        {{ label }}
      </v-col>
      <v-col
        v-if="item"
        cols="auto"
      >
        <v-btn
          text
          small
          color="primary"
          class="text-none"
          @click.stop="$emit('replace', item)"
        >
          {{ $t('button.replace') }}
        </v-btn>
      </v-col>
      <v-col
        v-if="item"
        cols="auto"
      >
        <v-btn
          text
          small
          color="primary"
          class="text-none"
          :href="item"
          target="_blank"
        >
          {{ $t('button.download') }}
        </v-btn>
      </v-col>
      <v-col
        v-else
        cols="auto"
      >
        <v-btn
          text
          small
          :loading="fileUpload.submitting"
          color="primary"
          class="text-none"
          @click.stop="$emit('replace')"
        >
          {{ $t('button.upload') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { EventTypes } from '@/data/models'

export default {
  name: 'EventSourceItem',
  props: {
    item: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    fileUpload: {
      type: Object,
      required: true
    }
  },
  created() {
    this.eventTypes = EventTypes
  },
  methods: {
  }
}
</script>
